import { Avatar, Group, Stack, Text } from "@mantine/core";
import { forwardRef } from "react";
import { Mail, Man } from "tabler-icons-react";

export const CustomSelect = forwardRef(({ image, label, title, mail, ...others }, ref) => (
  <div ref={ref} {...others} style={{ borderBottom: "1px solid #E9ECEF" }}>
    <Group noWrap>
      <Avatar src={image} />

      <div>
        <Text size="md">{label}</Text>

        <Stack spacing={10} align={"baseline"}>
          <Group position="center">
            <Text size="xs" opacity={0.65}>
              {mail}
            </Text>
          </Group>
        </Stack>
      </div>
    </Group>
  </div>
));
